<ng-container *ngIf="!item.hidden">
  <span class="navigation-section-text" [ngClass]="item.id" [translate]="item.translate">{{ item.title }}</span>
  <!-- More icon in collapsed menu -->
  <span [data-feather]="'more-horizontal'"></span>
</ng-container>
